import ContextMenuComponent from '../../../../organisms/context-menu'
import { MenuTitle, MenuTitleContainer } from '../../styled-components'

const MenuHeaderSection = ({ title, options }) => {
  if (!title || !options) return null

  return (
    <>
      <MenuTitleContainer>
        <MenuTitle>{title.toUpperCase()}</MenuTitle>
      </MenuTitleContainer>
      {options.map((option) => (
        <ContextMenuComponent.Item key={String(option.id)} {...option} />
      ))}
    </>
  )
}

export default MenuHeaderSection
